module.exports = __webpack_public_path__ + "static/img/200110.fe6cafcd.png";